"use strict";
// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
Object.defineProperty(exports, "__esModule", { value: true });
var lineHeights = {
    "lineheight16": "1.00",
    "lineheight32": "2.00",
    "lineheight28": "1.75",
    "lineheight24": "1.50",
    "lineheight20": "1.25",
    "lineheight18": "1.13",
    "lineheight40": "2.50",
    "lineheight48": "3.00",
    "h1": "1.30",
    "h2": "1.30",
    "h3": "1.30",
    "h4": "1.30",
    "h5": "1.30",
    "h6": "1.50",
    "body": "1.50",
    "small": "1.40",
    "mini": "1.30",
    "code": "1.50",
    "codeSmall": "1.40",
    "button": "1.5rem"
};
exports.default = lineHeights;
//# sourceMappingURL=lineHeights.js.map